import { render, staticRenderFns } from "./InvestmentTest.vue?vue&type=template&id=b02925a2&scoped=true&"
import script from "./InvestmentTest.vue?vue&type=script&lang=js&"
export * from "./InvestmentTest.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentTest.vue?vue&type=style&index=0&id=b02925a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02925a2",
  null
  
)

export default component.exports